import { UtilityProgramViewConfig } from '@/types/utilityProgram'
import { Button, Modal } from '@/components'
import { ConfigurableText } from 'app-components'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'

type Props = {
  open: boolean
  onClose: () => void
  onContinue: () => void
  viewConfig?: UtilityProgramViewConfig
}

export default function UnenrollConfirmationModal({
  open,
  onClose,
  onContinue,
  viewConfig,
}: Props) {
  const unenrollConfig = viewConfig?.scheduler?.disenrollConfirmation
  const title = unenrollConfig?.title ?? 'Unenroll from this Program'

  return (
    <Modal
      id="utility-program-disenroll-confirmation-modal"
      open={open}
      onClose={onClose}
      title={title}
    >
      <ConfigurableText
        className="!mb-3"
        variant="body2"
        config={unenrollConfig?.description}
      >
        Are you sure you want to unenroll from this program?
      </ConfigurableText>
      <ButtonContainer>
        <Button
          id="utility-program-disenroll-confirmation-back-button"
          variant="primary"
          onClick={onClose}
        >
          Back
        </Button>
        <Button
          id="utility-program-disenroll-confirmation-disenroll-button"
          variant="secondary"
          onClick={onContinue}
        >
          {unenrollConfig?.primaryButton?.text ?? 'Unenroll'}
        </Button>
      </ButtonContainer>
    </Modal>
  )
}
